import { StyleSheet } from 'react-native';
import { PALETTE } from '../../../constants';

export default StyleSheet.create({
  flag: {
    width: 340,
    top: -10,
    left: -170,
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    paddingTop: 10,
    paddingBottom: 20,
    paddingHorizontal: 6,
    height: 100,
    // boxShadow: "0.5px 0.5px 1px 0.5px #000",
    borderRadius: 2
  },
  cardHeaderView: {
    width: '100%',
  },
  cardBodyView: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginLeft: '5%',
    marginRight: '5%',
  },
  textStyle:{
    textAlign: 'center', 
    color: '#ffffff',
  }
});
